import { ActionSequence } from 'src/lib/ActionSequence';
import i18n from 'src/lib/i18n/i18n';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import { logoutNativeApp } from 'src/lib/native/native.util';
import platform from '@play-co/gcinstant';
import { Native, NativePromoOrigin } from 'src/replicant/native';
import { isNativePromoAvailable } from './native.util';
import { trackAppPromoPopupOpen } from 'src/lib/analytics/events';
import { getDynamicTestBucket } from 'src/replicant/getters/ab';
import ab from 'src/replicant/ruleset/ab';
import StateObserver from 'src/StateObserver';

export const startLogoutSequence = () =>
  ActionSequence.start(
    [
      async function showConfirmationPopup() {
        return !(await openPopupPromise('popupConfirmation', {
          title: i18n('native.logout.confirmation.title'),
          message: i18n('native.logout.confirmation.message'),
          buttonOkay: i18n('native.logout.confirmation.ok'),
        }));
      },

      async function logout() {
        logoutNativeApp();
        return false;
      },
    ],
    'Logout',
  );

export const startInstallNativeSequence = async (origin: NativePromoOrigin) => {
  if (!isNativePromoAvailable()) {
    return;
  }

  // Send analytics
  trackAppPromoPopupOpen(origin);

  // Ab test
  const test = 'control';
  if (platform.osType === 'IOS') {
    await openPopupPromise('popupInstallAppIos', {});
  } else if (platform.osType === 'ANDROID') {
    await openPopupPromise('popupInstallAppAndroid', {});
  }
  /*
  switch (test) {
    case 'exclusive_character':
      await openPopupPromise('popupInstallNativeApp', {});
      break;
    case 'reward':
      await StateObserver.invoke.installRewardWasShown();
      await openPopupPromise('popupInstallNativeApp', {});
      break;
    default:
      // Open app install popup for current platform
    
      break;
  }
  */
};

/**
 * Native app reward install sequence
 * TEST_APP_INSTALL_NUDGE_POPUP_VARIANT
 */
export async function startInstallAppRewardSequence(): Promise<boolean> {
  const { user } = StateObserver.getState();
  // Ab test
  const test = false;

  // Only for reward test
  return false;

  /*
  // Do we have non claimed reward?
  if (Native.api.hasAppInstallReward(user)) {
    await openPopupPromise('popupInstallNativeReward', {});
    await StateObserver.invoke.claimInstallReward();
  }*/
}
